import 'angular:locale/data:en-US';
import '@angular/localize/init';
import 'zone.js';
import './src/amaplan-polyfill.ts';(globalThis.$localize ??= {}).locale = "en-US";
